module.exports = __webpack_public_path__ + "img/avatar2.0019fbb1.png";